import { Button } from '@velocity/ui';
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Layout from '../../../layout';
import { EDevice } from '../../../redux/sequence/enums';
import { RootState } from '../../../redux/store';
import ArrowList from '../../b2b/components/arrow-list/arrow-list';
import Contact from '../contact/contact';
import { ReactComponent as AuthentificationFailedSmall } from '/src/assets/svg/authentification_failed_small.svg';
import { ReactComponent as AuthentificationFailedSvg } from '/src/assets/svg/authentification_not_available.svg';

const StatusAuthentificationFailed: React.FC = () => {
  const { device } = useSelector((state: RootState) => state.sequence);

  const headline = (
    <>
      {device === EDevice.MOBILE && (
        <AuthentificationFailedSmall className='status-svg mb-6' />
      )}
      <div>Deine Identifikation konnte nicht abgeschlossen werden</div>
    </>
  );

  const getSubHeading = () => {
    return 'Die Identifikation wurde leider nicht erfolgreich beendet. Dein Leasingantrag kann deshalb aktuell nicht fortgeführt werden.';
  };

  const navigate = useNavigate();

  return (
    <Layout
      heading={headline}
      subHeading={getSubHeading()}
      hasFullSize={true}
      className='status-overview top-96 grid'
      style={{ gridTemplateRows: '15% 60%' }}
    >
      <div
        className='half-half-columns cancelled top-36'
        style={{ alignItems: 'start' }}
      >
        {(device === EDevice.DESKTOP || device === EDevice.TABLET) && (
          <AuthentificationFailedSvg className='status-svg' />
        )}
        <div className='flex flex-col gap-4'>
          <div className='content-bold'>Was du jetzt tun kannst</div>

          <ArrowList
            className='dark-grey content-normal'
            list={[
              'Über den Button kannst du die Identifikation erneut starten.',
              'Halte bitte deinen Ausweis bereit und achte auf eine stabile Internetverbindung.',
            ]}
          />

          <Button
            variant='secondary-filled'
            size='m'
            fullWidth
            margin={{ y: '06' }}
            onClick={() => navigate('/idNow')}
          >
            Identifikation erneut starten
          </Button>

          <Contact />
        </div>
      </div>
    </Layout>
  );
};

export default StatusAuthentificationFailed;
